import IconButtonDo from "../../../../../../packages/design-system/button/constellation/icon-button/images/dos-donts/icon-common-do.png";
import IconButtonDont from "../../../../../../packages/design-system/button/constellation/icon-button/images/dos-donts/icon-common-dont.png";
import * as React from 'react';
export default {
  IconButtonDo,
  IconButtonDont,
  React
};